import { HrefParams } from '../directives/href/href.directive';
import { SymbolType } from './symbol.domain';
import { OrderOperation } from './trading.domain';

export enum TradeAction {
  BUY = 'buy',
  SELL = 'sell'
}

export interface BaseTradeInfo extends HrefParams {
  accountId: string;
  symbol: string;
  market: string;
  securityType: SymbolType;
  quantity?: number;
  optionNonStandard?: boolean;
}

export interface TradeInfo extends BaseTradeInfo {
  cusip?: string;
  accounts?: Array<string>;
}

export interface TradeParams extends BaseTradeInfo {
  operation: OrderOperation.CREATE;
  action: TradeAction;
  accounts?: Array<string>;
  simplifiedOrder?: boolean;
}

export interface FixedIncomeTradeParams extends HrefParams {
  accountId: string;
  orderAction: 'orderEntry';
  orderSubAction: TradeAction;
  orderQty: number;
  cusip: string;
}
